import { Box, Text } from '@factorialco/deprecated-design-system'

import MinutesToText from 'modules/attendance/components/MinutesToText'

interface Props {
  title: string
  value: number
}

const Item = ({ title, value }: Props) => (
  <Box flexDirection="row" justifyContent="spaceBetween">
    <Text color="grey1000" size="200">
      {title}
    </Text>
    <MinutesToText color="grey1000" value={value} size="200" />
  </Box>
)

export default Item
